import React from 'react'
import './Device.css'
import Inner from './Inner'
import Outer from './Outer'
import Switches from './Switches'
import Preview from './Preview'

export const Device = ({ className, style, clickEvent }) => {

	const handleClick = (color) => {
		return () => {
			clickEvent(color);
		}
	}

	return (
		<svg
			className={className + " block-diagram"}
			style={style}
			height="700"
			width="1000"
			viewBox="0 0 1000 700">
			<Outer />
			<Inner />
			<Switches />
			<Preview />
			<rect
				className="zone red"
				x="545"
				y="145"
				width="80"
				height="130"
				onClick={handleClick("red")}
			/>
			<rect
				className="zone green"
				x="610"
				y="65"
				width="320"
				height="110"
				onClick={handleClick("green")}
			/>
			<rect
				className="zone purple"
				x="650"
				y="200"
				width="280"
				height="245"
				onClick={handleClick("purple")}
			/>
			<rect
				className="zone gray"
				x="500"
				y="425"
				width="440"
				height="165"
				onClick={handleClick("grey")}
			/>
			<rect
				className="zone blue"
				x="195"
				y="475"
				width="100"
				height="80"
				onClick={handleClick("blue")}
			/>
			<rect
				className="zone orange"
				x="90"
				y="20"
				width="295"
				height="110"
				onClick={handleClick("orange")}
			/>
		</svg>
	)
}
export default Device
